import React from 'react';
import './home.css';
import updates from '../../contents/updates.json'
import LinkBox from "../../components/LinkBox";
import {SEO} from "../../components/SEO";

function Index() {
    return (
        <div className={'flex flex-col gap-y-4'}>
            <SEO isDefault />
            <div className="box">
                <div className="tape"></div>
                <h2 className={'font-bold text-xl'}>更新履歴</h2>
                {
                    Object.keys(updates).map((date, index) => (
                        <p key={index} className={`text-center ${index === 0 && 'font-bold'}`}>
                            {date} - {JSON.parse(JSON.stringify(updates))[date]}
                        </p>
                    ))
                }
              {/*<span className="tape2"></span>*/}
            </div>

            <nav className={'flex flex-col gap-y-2'}>
                <LinkBox text={'ABOUT US'} img={'about'} link={'/about'} />
                <LinkBox text={'COMICS'} img={'comics'} link={'/comics'} />
                <LinkBox text={'ILLUSTRATIONS'} img={'illustrations'} link={'/illustrations'} />
                <LinkBox text={'CONTACT'} img={'contact'} link={'/contact'} />
            </nav>
        </div>
    );
}

export default Index;